import request from '@/utils/request'

// 查询发现-热搜帖子人工配置列表
export function listDiscoverHotPostConf(query) {
  return request({
    url: '/discovery/discovery/hot/post/conf/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现-热搜帖子人工配置分页
export function pageDiscoverHotPostConf(query) {
  return request({
    url: '/discovery/discovery/hot/post/conf/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现-热搜帖子人工配置详细
export function getDiscoverHotPostConf(data) {
  return request({
    url: '/discovery/discovery/hot/post/conf/detail',
    method: 'get',
    params: data
  })
}

// 新增发现-热搜帖子人工配置
export function addDiscoverHotPostConf(data) {
  return request({
    url: '/discovery/discovery/hot/post/conf/add',
    method: 'post',
    data: data
  })
}

// 修改发现-热搜帖子人工配置
export function updateDiscoverHotPostConf(data) {
  return request({
    url: '/discovery/discovery/hot/post/conf/edit',
    method: 'post',
    data: data
  })
}

// 删除发现-热搜帖子人工配置
export function delDiscoverHotPostConf(data) {
  return request({
    url: '/discovery/discovery/hot/post/conf/delete',
    method: 'post',
    data: data
  })
}

// 删除发现-热搜帖子人工配置
export function batchAddDiscoverHotPostConf(data) {
  return request({
    url: '/discovery/discovery/hot/post/conf/batchAdd',
    method: 'post',
    data: data
  })
}

// 删除发现-热搜帖子人工配置
export function changeSortDiscoverHotPostConf(data) {
  return request({
    url: '/discovery/discovery/hot/post/conf/changeSort',
    method: 'post',
    data: data
  })
}
